import _ from 'underscore';
import { CampaignNegativeKeyword, AdGroupNegativeKeyword } from '@bingads-webui-campaign/campaign-ui-schemas';

export const gridType = {
  campaign: 'campaign',
  adgroup: 'adgroup',
};


export function getSchema(type) {
  if (type === gridType.campaign) {
    return CampaignNegativeKeyword;
  } else if (type === gridType.adgroup) {
    return AdGroupNegativeKeyword;
  }

  throw new Error('unknown negative keyword grid type.');
}

export function patchParentObj(item) {
  const toPatch = item.AdGroupId ?
    { AdGroup: { Id: item.AdGroupId } } :
    { Campaign: { Id: item.CampaignId } };

  return _.defaults(toPatch, item);
}
